export const setPayload = ({
  LastModifiedDateFrom,
  UploadedDateFrom,
  UploadedDateTo,
  InvoiceStatusID
}) => {
  const payload = {}

  if (LastModifiedDateFrom) {
    payload.LastModifiedDateFrom = LastModifiedDateFrom
  }

  if (UploadedDateFrom) {
    payload.UploadedDateFrom = UploadedDateFrom
  }

  if (UploadedDateTo) {
    payload.UploadedDateTo = UploadedDateTo
  }

  if (InvoiceStatusID) {
    payload.InvoiceStatusID = InvoiceStatusID?.value
  }

  return payload
}
